import instance from './base';

export async function getStatisticsCatalog() {
  const rsp = await instance.get('/v1/statistics/appointments/catalog');
  return rsp.data;
}

export async function queryAppointmentStatistics(spec) {
  const rsp = await instance.post('/v1/statistics/appointments', spec);
  return rsp.data;
}
